import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const PayrollComplianceChart = ({ data, chartType = 'combined' }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-md shadow-lg p-3">
          <p className="font-body font-medium text-sm text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 text-xs">
              <span className="caption text-muted-foreground">{entry?.name}:</span>
              <span className="data-text font-medium" style={{ color: entry?.color }}>
                {entry?.name?.includes('Rate') || entry?.name?.includes('Compliance') 
                  ? `${entry?.value}%` 
                  : `K${entry?.value?.toLocaleString()}`}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
          Payroll Cost & Compliance Trends
        </h3>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 rounded-sm bg-primary"></div>
            <span className="text-xs caption text-muted-foreground">Payroll Cost</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 rounded-sm bg-success"></div>
            <span className="text-xs caption text-muted-foreground">Compliance</span>
          </div>
        </div>
      </div>

      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Payroll Cost and Compliance Trends Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-caption)' }}
            />
            <YAxis 
              yAxisId="left"
              stroke="var(--color-primary)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-data)' }}
              tickFormatter={(value) => `K${value / 1000}k`}
            />
            <YAxis 
              yAxisId="right"
              orientation="right"
              stroke="var(--color-success)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-data)' }}
              tickFormatter={(value) => `${value}%`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px', fontFamily: 'var(--font-caption)' }}
            />
            <Line 
              yAxisId="left"
              type="monotone" 
              dataKey="payrollCost" 
              stroke="var(--color-primary)" 
              strokeWidth={2}
              name="Payroll Cost (PGK)"
              dot={{ fill: 'var(--color-primary)', r: 4 }}
            />
            <Line 
              yAxisId="right"
              type="monotone" 
              dataKey="complianceRate" 
              stroke="var(--color-success)" 
              strokeWidth={2}
              name="Compliance Rate"
              dot={{ fill: 'var(--color-success)', r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PayrollComplianceChart;